import { withTestPageObjectRegistration } from "../../../../Services/TestPageObjects/PageObjectExposure";

import { Counter } from "./Counter";

export const CounterContainer = withTestPageObjectRegistration(Counter, () => ["Counter"]);
